<template>
  <a-modal
    v-model="dialogVisible"
    title="理赔记录"
    :mask-closable="false"
    width="1000px"
  >
    <jczh-table-content :data="list" :option="listOption" />
    <template v-slot:footer>
      <a-button type="primary" @click="dialogVisible = false">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
import { getOnlineLetterClaimHistoryApi } from '@/api/procure/invite-bid'
import { guaranteeLetterOnlineClaimStatusDict } from '@/dictionary/project/common'

/**
 * @description 线上保函理赔历史记录
 */
export default {
  name: 'OnlineLetterClaimHistory',

  props: {
    visible: {
      type: Boolean,
      default: false
    },

    trade: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      list: [],
      listOption: [
        { label: '操作时间', prop: 'createTime' },
        {
          label: '理赔状态',
          prop: 'statusEnum',
          filter: value =>
            guaranteeLetterOnlineClaimStatusDict.translate(value)?.label || '-'
        },
        { label: '联系人', prop: 'contactName' },
        { label: '联系电话', prop: 'contactPhone' },
        { label: '理赔原因', prop: 'reason', minWidth: '200px' },
        { label: '赔付金额（元）', prop: 'claimAmount' },
        { label: '更新时间', prop: 'claimTime' },
        { label: '拒绝原因', prop: 'refuseReason', minWidth: '200px' }
      ]
    }
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },

  watch: {
    visible(val) {
      if (val) this.getHistory()
    }
  },

  methods: {
    async getHistory() {
      try {
        const { data = {} } = await getOnlineLetterClaimHistoryApi({
          orderId: this.trade.orderId,
          tradeId: this.trade.tradeId
        })
        this.list = data?.claimReasonDtoList || []
      } catch (err) {
        console.error('获取保函理赔历史记录失败', err)
        if (err?.message) this.$message.error(err.message)
      }
    }
  }
}
</script>

<style scoped></style>
